import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from  'react-router-dom';
import Home from './onboarding/Home';
import FarmCalculator from './onboarding/FarmCalculator';
import SpaceCalculator from './calculator/space/SpaceCalculator';
import FeedCalculator from './calculator/feed/FeedCalculator';
import EggCalculator from './calculator/egg/EggCalculator';
import VaccineCalculator from './calculator/vaccine/VaccineCalculator';
import Error from './onboarding/Error'
import ExpiredLink from './onboarding/ExpiredLink';
import Privacy from './legal/Privacy';
import Terms from './legal/Terms';
import { Provider } from 'react-redux';
import { Store } from './redux/store';
import ScrollToTop from './snippets/ScrollToTop';
import useGoogleAnalytics from './action/useGoogleAnalytics';
import { TEST_MODE } from './action/constant';

function App() {
  useGoogleAnalytics("G-JKWGJ86LX7");

  return (
    <Provider store={Store}> 
      <Router>
        <ScrollToTop/>
        {TEST_MODE && (
          <div className='check-email-popup' style={{position:'fixed', top: "5px",left: "50%", transform: "translateX(-50%)", width:"auto", height:"auto", color:"#FFF", padding:"10px", fontSize:'12px'}}>
            Test mode
          </div>
        )}
        <Routes> 
          <Route path='/' exact element={<Home/>} />
          <Route path='/farmcalculator' exact element={<FarmCalculator/>} />
          <Route path='/farm-calculator' exact element={<FarmCalculator/>} />
          <Route path='/space-calculator' exact element={<SpaceCalculator/>} />
          <Route path='/feed-calculator' exact element={<FeedCalculator/>} />
          <Route path='/egg-calculator' exact element={<EggCalculator/>} />
          <Route path='/vaccine-calculator' exact element={<VaccineCalculator/>} />
          <Route path='/privacy-policy' exact element={<Privacy/>}/>
          <Route path='/terms' exact element={<Terms/>}/>
          <Route path='/expired-link' exact element={<ExpiredLink/>}/>
          <Route path='*' exact element={<Error/>} />
        </Routes>

      </Router>
    </Provider>
  );
}

export default App;
